import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {generateComponentCallback} from '/util/component.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './CabEligibleBonusIndicator.style';

interface CabEligibleBonusIndicatorProps {
  item: {
    newOrderingEntityCount: number;
  };
  tt: any;
}

export const CabEligibleBonusIndicator = ({
  item,
  tt,
}: CabEligibleBonusIndicatorProps) => {
  const featureFlag = useSelector(variablesFeatureFlag);

  const showBusinessPrograms = shouldReleaseFeature(
    get(featureFlag, 'ff_hide_business_programs', ''),
  );

  const newOrderingEntityCount = item?.newOrderingEntityCount ?? 0;
  const bonusIndicatorText = {
    [2]: '1 away from first bonus',
    [4]: '1 away from full bonus',
  };

  return (
    <View>
      {(newOrderingEntityCount === 4 || newOrderingEntityCount === 2) &&
        !showBusinessPrograms &&
        tt(
          'clientBonusIndicator',
          generateComponentCallback({
            component: (
              <Text
                variant="button"
                style={styles.bonusIndicatorText}
                {...testProperties(Reports.reportOEawayFromBonus)}>
                {bonusIndicatorText[newOrderingEntityCount]}
              </Text>
            ),
          }),
        )}
    </View>
  );
};

export default withTranslation('report.record.CabEligibleBonusIndicator')(
  CabEligibleBonusIndicator,
);
